"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
var _blacklist = require("@/api/log/blacklist");
var _RateLimitConfig = _interopRequireDefault(require("@/views/cfg/RateLimitConfig.vue"));
var _GrayRouteConfig = _interopRequireDefault(require("@/views/cfg/GrayRouteConfig.vue"));
var _GrayRouteLog = _interopRequireDefault(require("@/views/cfg/GrayRouteLog.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'rateLimitBlacklist',
  components: {
    RateLimitConfig: _RateLimitConfig.default,
    GrayRouteConfig: _GrayRouteConfig.default,
    GrayRouteLog: _GrayRouteLog.default
  },
  data: function data() {
    return {
      activeTab: 'blacklist',
      loading: false,
      list: [],
      total: 0,
      queryParams: {
        page: 1,
        limit: 10,
        targetType: null,
        targetValue: null
      },
      blockVisible: false,
      blockLoading: false,
      blockForm: {
        targetType: 'IP',
        targetValue: '',
        permanent: true,
        durationSeconds: 300
      },
      blockRules: {
        targetType: [{
          required: true,
          message: '请选择类型',
          trigger: 'change'
        }],
        targetValue: [{
          required: true,
          message: '请输入目标值',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _blacklist.getBlacklistPage)(this.queryParams).then(function (response) {
        _this.list = response.data.list || [];
        _this.total = response.data.total || 0;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.queryParams.limit = size;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.queryParams.page = current;
      this.getList();
    },
    handleAdd: function handleAdd() {
      this.blockForm = {
        targetType: 'IP',
        targetValue: '',
        permanent: true,
        durationSeconds: 300
      };
      this.blockVisible = true;
    },
    onPermanentChange: function onPermanentChange(val) {
      if (val) {
        this.blockForm.durationSeconds = 0;
      } else {
        this.blockForm.durationSeconds = 300;
      }
    },
    submitBlock: function submitBlock() {
      var _this2 = this;
      this.$refs.blockForm.validate(function (valid) {
        if (!valid) return;
        _this2.blockLoading = true;
        var params = {
          targetType: _this2.blockForm.targetType,
          targetValue: _this2.blockForm.targetValue,
          durationSeconds: _this2.blockForm.permanent ? 0 : _this2.blockForm.durationSeconds
        };
        (0, _blacklist.blockTarget)(params).then(function () {
          _this2.$message.success(_this2.blockForm.permanent ? '永久封禁成功' : '封禁成功');
          _this2.blockVisible = false;
          _this2.blockLoading = false;
          _this2.getList();
        }).catch(function () {
          _this2.blockLoading = false;
        });
      });
    },
    handleUnblock: function handleUnblock(row) {
      var _this3 = this;
      this.$confirm('确认解封 ' + row.targetType + '=' + row.targetValue + ' ?', '解封确认', {
        confirmButtonText: '确认解封',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _blacklist.unblockTarget)(row.id).then(function () {
          _this3.$message.success('解封成功');
          _this3.getList();
        });
      }).catch(function () {});
    },
    formatDateTime: function formatDateTime(date) {
      if (!date) return '';
      var d = new Date(date);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      var hours = String(d.getHours()).padStart(2, '0');
      var minutes = String(d.getMinutes()).padStart(2, '0');
      var seconds = String(d.getSeconds()).padStart(2, '0');
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    }
  }
};